var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.02911 17.9995H0.297321V5.98216H4.02911V17.9995ZM2.16121 4.34288C0.967902 4.34288 0 3.35449 0 2.1612C8.54116e-09 1.58801 0.227698 1.0383 0.633002 0.632999C1.03831 0.227697 1.58802 0 2.16121 0C2.73439 0 3.2841 0.227697 3.68941 0.632999C4.09471 1.0383 4.32241 1.58801 4.32241 2.1612C4.32241 3.35449 3.35411 4.34288 2.16121 4.34288ZM17.996 17.9995H14.2722V12.1495C14.2722 10.7554 14.2441 8.96741 12.332 8.96741C10.3918 8.96741 10.0945 10.4821 10.0945 12.0491V17.9995H6.3667V5.98216H9.9458V7.62144H9.99804C10.4963 6.67725 11.7133 5.68082 13.5289 5.68082C17.3057 5.68082 18 8.16786 18 11.3982V17.9995H17.996Z",
    fill: "#FCA905"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ae197b51.svg";
export { ForwardRef as ReactComponent };